import * as React from 'react';
import RouterSingleton from 'next/router';

import {
  TrackingFunctions,
  TrackingMiddleware,
  TrackingProvider as Provider,
  configureTracking,
  createEventTracker,
} from '@zapier/toolbox-tracking';

configureTracking({
  // This has to be 'web' see following slack thread
  // https://zapier.slack.com/archives/C406QGE15/p1605895155293500
  service: 'web',
  release: `${process.env.NEXT_PUBLIC_COMMIT_SHA}`,
});

const attachSSRMetadata: TrackingMiddleware = () => async event => {
  event.apply({
    pageRoute: RouterSingleton.route,
    path: RouterSingleton.asPath,
  });
};

export const trackingFunctions: TrackingFunctions = createEventTracker([
  attachSSRMetadata,
]);

type Props = {
  children: React.ReactNode;
};

export function TrackingProvider({ children }: Props) {
  return <Provider trackingFunctions={trackingFunctions}>{children}</Provider>;
}
